module.exports = __webpack_public_path__ + "img/success.2fb456b5.png";